export default __webpack_public_path__ + "static/media/empty-orders.b95b4c8e.svg";